import { HelpCenterAccordion } from "../HelpCenterAccordion"
import { HelpCenterCard } from "../HelpCenterCard"

export const MembershipSection = () => {
    return (
        <div className="help-center-section-content">
            <span className="title">
                Membership & Loyalty
            </span>

            <p className="help-center-text">
                As a member of Nobilis, you gain lifelong access to our community of ultra-high achievers. Membership is bound by an initiation fee and annual renewal to maintain active status. Members agree to uphold confidentiality, respect, and integrity in all interactions. Failure to comply with our standards may result in suspension or removal from the community.
            </p>

            <div className="elements">
                <HelpCenterAccordion
                    title="Loyalty Program Overview"
                    content={
                        <>
                            <p className="help-center-subtext">
                                Nobilis recognizes and rewards engagement. Members who actively host experiences, share expertise, or expand the community gain privileges such as reduced annual fees, additional connection requests, or priority access to special experiences. Loyalty is not transactional — it reflects your commitment to shaping and enriching the community.
                            </p>
                            <ul className="help-center-ul">
                                <li>Benefits & Privileges</li>
                                <li>Access to curated experiences worldwide</li>
                                <li>Ability to host your own experiences and private gatherings</li>
                                <li>Complimentary connection requests each year</li>
                                <li>Invitations to exclusive forums and think tanks</li>
                                <li>Access to Nobilis Concierge services</li>
                            </ul>
                        </>
                    }
                />

                <HelpCenterCard 
                    title="Managing Your Membership"
                    content="You may update your membership details, review your loyalty standing, or adjust your annual status through your personal dashboard." 
                    target="/help-center/0"
                />

            </div>
        </div>
    )
}